import devaPic from "@/public/images/artists/deva.png";
import { Artist } from "@/types/types";

export const deva = {
  id: "121",
  name: "Deva",
  image: devaPic,
  description: `Deva possesses an emotive and storytelling quality in her voice, particularly suited for ballads. There's a youthful essence to her delivery that adds depth to her performances.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fdeva-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Dance", "Latin"],
      secondary: ["Alluring", "Spanish"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 54,
        high: 70,
      },
    },
  },
} as const satisfies Artist;
